var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 92,
    viewBox: "0 0 106 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9978 70.1196H53.0456M52.9978 34.3246V52.2221M44.4869 5.79L2.33253 76.0854C1.46399 77.589 1.0046 79.2935 1.00003 81.0294C0.995465 82.7654 1.44588 84.4723 2.30649 85.9804C3.1671 87.4886 4.40793 88.7454 5.90562 89.626C7.4033 90.5066 9.10566 90.9803 10.8434 91H95.1522C96.8907 90.9821 98.5942 90.5095 100.093 89.6293C101.592 88.7491 102.833 87.4921 103.694 85.9833C104.555 84.4746 105.005 82.7668 105 81.0302C104.994 79.2936 104.534 77.5887 103.663 76.0854L61.5147 5.79C60.6282 4.32795 59.3791 3.11899 57.8883 2.27991C56.3974 1.44083 54.7151 1 53.0038 1C51.2926 1 49.6102 1.44083 48.1194 2.27991C46.6285 3.11899 45.3794 4.32795 44.4929 5.79",
    stroke: "#F4512E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.f2b2b555e81fd4db9e60d2aa8cdcd558.svg";
export { ForwardRef as ReactComponent };